import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';

class FormDuplicateButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired
    };

    static defaultProps = {
        positionClassName: null
    };

    render() {
        const { sendFunc, classes } = this.props;

        return (
            <div className={classes.firstPosition}>
                <Tooltip title={Translator.translate('general.duplicate')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.duplicate')}
                        className={`${classes.btnDuplicate} ${classes.fabSave}`}
                        size="small"
                        onClick={sendFunc}
                    >
                        <FileCopy className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 50,
        right: 50,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 30
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 20
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 18
        }
    },
    btnDuplicate: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30
        }
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    },
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    }
});

export default withStyles(styles, { withTheme: true })(FormDuplicateButton);



// WEBPACK FOOTER //
// ./data/components/FormDuplicateButton.js